import { useState } from 'react'

export default function Collapsible({ title, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className="border border-white/10 rounded-md">
      <button onClick={() => setOpen((x) => !x)}
              className="w-full px-3 py-2 flex items-center justify-between text-left">
        <span className="label-mini">{title}</span>
        <span className="opacity-60 text-sm">{open ? '−' : '+'}</span>
      </button>
      {open && <div className="px-3 pb-3 animate-system-open">{children}</div>}
    </div>
  )
}
